/** * @file TotalTable */
<template>
  <table class="table table-bordered">
    <thead>
      <th>合計件数</th>
      <th>合計申込金額</th>
    </thead>
    <tbody>
      <td v-if="showCount">{{ countStr }}</td>
      <td v-if="showPrice">{{ priceStr }}</td>
    </tbody>
  </table>
</template>

<script>
import {helperIsComma} from '@/js/util/helper.js'
export default {
  props: {
    count: {
      type: Number,
      default: 0
    },
    price: {
      type: Number,
      default: 0
    }
  },
  computed: {
    countStr() {
      if (!this.count) return ''

      return `${this.count}件`
    },
    priceStr() {
      if (!this.price) return ''

      return `${helperIsComma(this.price)}円`
    },
    showCount() {
      return this.count ? true : false
    },
    showPrice() {
      return this.price ? true : false
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  text-align: right;
  width: auto;
  margin-left: auto;
  th {
    background-color: #666;
    color: #fff;
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
